import AppSettings from "../appsettings";
import { apiFetch, apiUrl } from "./apiClient";

/**
 * Fetch a whole vehicle document archive ("sourcebooks" | "ebrochures") in one
 * request: every vehicle with at least one published PDF inside the rolling
 * eight-model-year window, years newest first. Filtering on the page is then
 * pure client-side work — no further network calls.
 *
 * The API returns bare S3 keys; this resolves them against the CDN.
 */
export async function getDocumentArchive(type) {
  const response = await apiFetch(apiUrl(`/static/archive/${type}`));

  if (!response.ok) {
    throw new Error(`Failed to load the ${type} archive (${response.status})`);
  }

  const { vehicles = [] } = await response.json();

  return vehicles.map((vehicle) => ({
    ...vehicle,
    years: vehicle.years.map(({ year, key }) => ({
      year,
      url: `${AppSettings.cloudFrontURL}/${key}`,
    })),
  }));
}
